import { render, staticRenderFns } from "./DraggableWrapper.vue?vue&type=template&id=6b892c17&scoped=true&"
import script from "./DraggableWrapper.vue?vue&type=script&lang=js&"
export * from "./DraggableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DraggableWrapper.vue?vue&type=style&index=0&id=6b892c17&lang=scss&scoped=true&"
import style1 from "./DraggableWrapper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b892c17",
  null
  
)

export default component.exports